import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AbstractField } from '@ordersnproducts/modules/shared/modules/configurable-form/models/field-configs/abstract-field';
import { select, Store } from '@ngrx/store';
import { State } from '@ordersnproducts/modules/one-click-order/reducers';
import {
  OneClickLoadOrderPricesAction,
  OneClickProfileResetPricesAction,
  OneClickSetProfilePricesBlocked,
} from '@ordersnproducts/modules/one-click-order/actions/one-click-profile.actions';
import { getOneClickProfileStatePrices } from '@ordersnproducts/modules/one-click-order/selectors/one-click-profiles.selector';
import { UntypedFormControl } from '@angular/forms';
import { CmxSpinnerService } from '@ordersnproducts/modules/shared/components/cmx-spinner/cmx-spinner.service';
import { Price } from '@ordersnproducts/modules/one-click-order/models/price';
import { Prices } from '@ordersnproducts/modules/one-click-order/models/prices';
import { getOneClickPricesValidatorParams } from '@ordersnproducts/modules/one-click-order/selectors/one-click-prices-validator.selector';

@Component({
  selector: 'app-prices',
  templateUrl: './prices.component.html',
  styleUrls: ['./prices.component.scss'],
})
export class PricesComponent extends AbstractField implements OnInit {
  @Output()
  formChanged = new EventEmitter<string>();
  public profileStatePrices: Prices;
  public price: Price;
  public isReadyForPrices: boolean;
  private formControl: UntypedFormControl;

  constructor(
    private store: Store<State>,
    private spinner: CmxSpinnerService,
  ) {
    super();
    this.spinner.show();
  }

  ngOnInit() {
    this.isReadyForPrices = false;
    this.formControl = this.getControl() as UntypedFormControl;
    this.formControl.setValue(false);
    this.store.pipe(select(getOneClickProfileStatePrices)).subscribe((state) => {
      this.profileStatePrices = state;
      if (this.profileStatePrices) {
        this.store.dispatch(new OneClickSetProfilePricesBlocked(true));
      }
      if (this.profileStatePrices && this.profileStatePrices.prices && this.profileStatePrices.prices.length > 0) {
        this.price = this.profileStatePrices.prices[0];
        this.formControl.setValue(!(this.profileStatePrices.applyCharges && this.profileStatePrices.prices));
      } else {
        this.formControl.setValue(false);
      }
    });

    this.store.pipe(select(getOneClickPricesValidatorParams)).subscribe((state) => {
      this.isReadyForPrices = !!state && !!state.quantity && !!state.unit.selected && !!state.payment.selected;
    });
  }

  public getPrices() {
    this.store.dispatch(new OneClickLoadOrderPricesAction());
  }

  public editPrices() {
    this.store.dispatch(new OneClickSetProfilePricesBlocked(false));
    this.resetPrices();
  }

  private resetPrices() {
    this.store.dispatch(new OneClickProfileResetPricesAction());
    this.profileStatePrices = null;
    this.price = null;
  }
}
